import { Component, ElementRef } from "@angular/core";
import { Folder, Dataset, TransformType } from "4d-mapper";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription, Subject, combineLatest } from "rxjs";
import { FileDataService, FileUpload, TaskProcessing, FileEvent, FolderEvent } from "../commons/file-data.service";
import { Location } from "@angular/common";
import { ArrayStore, Store } from 'vasat/dist/src/veflux'
import { TreeEvent, TreeNode, TreeNodeBuilder } from "../commons/files/tree-events";
import { FormControl } from "@angular/forms";
import { debounceTime } from "rxjs/operators";
import { Account } from "vasat";
import { KeyboardService } from "../commons/keyboard.service";


@Component({
  selector: 'main-comp',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
})
export class MainComponent{
  
  processing:TaskProcessing[] = []
  uploads:FileUpload[] = []
  uploadsQueued:FileUpload[] = []
  folderRoot = new ArrayStore(TreeEvent)
  private _subs:Subscription[] = []
  
  selectedFiles:Dataset[] = []
  curAdHoc:TransformType

  displayedFilesStore = new ArrayStore(FileEvent)
  selectedFilesStore = new ArrayStore(FileEvent,[],this.displayedFilesStore)
  selectedFolderStore = new Store(TreeEvent)
  

  searchFolders:Folder[] = []
  searchFiles:Dataset[] = []

  searchController = new FormControl()
  searchText:string

  
  constructor(private route:ActivatedRoute,     public fileManager:FileDataService,     private router:Router , private keys:KeyboardService, private builder:TreeNodeBuilder) {
  }

  ngOnInit(){
    //this.displayedFilesStore.subscribe(s => console.log('main D',s))
    //this.selectedFolderStore.subscribe(s => console.log('main S',s))
    //this.selectedFolderStore.subscribe(s => console.log('main F',s))
    
    this.fileManager.processingItems.events.subscribe(s => console.log('main P',s.event + " " + s.item.task.name))
    this.fileManager.uploadingFiles.events.subscribe(s => console.log('main UL',s.event + " " + s.item.dataset.name))
    
 
    // load active folder if specified in url
    this.route.params.subscribe(s => {
      if(!s.folderId ) return
      else if(s.folderId == 'root')
        this.fileManager.onTeamReady().subscribe(t => this.selectedFolderStore.value = this.builder.fromAccount(t.item))
      else{
        this.setFolder(s.folderId)
      }
    })

    // load selectedFiles using query params
    this._subs.push(combineLatest(this.displayedFilesStore.events,this.route.queryParams).subscribe(([ev,param]) => {
      if(!param.files ){
        this.selectedFilesStore.values = []
      }
      else{
        var fileIds = param.files.split(',').map(s => parseInt(s))

        // set selected from loaded files (if query param cahges after files are loaded)
        this.selectedFilesStore.values = this.displayedFilesStore.values.filter( v => fileIds.indexOf(v.id) != -1)

        // add to selected (if file loaded after query param)
        if(ev.event == 'ADD' && fileIds.indexOf(ev.item.id) != -1){
          this.selectedFilesStore.add(ev.item)
        }
      }
    }))
    
    // on team ready and unload
    this._subs.push(this.fileManager.team.events.subscribe(s => {
      if(s.event == 'ADD'){
        this.folderRoot.set(this.builder.fromAccountProjects(s.item))
        this.folderRoot.set(this.builder.fromAccount(s.item))
      }
      if(s.event == 'REMOVE'){
        this.folderRoot.values = []
        this.displayedFilesStore.values = []
        this.selectedFilesStore.values = []
      }
    }))

    this._subs.push(this.selectedFilesStore.state.subscribe(s => this.selectedFiles = s))
    this._subs.push(this.fileManager.uploadingFiles.state.subscribe(s => this.uploads = s))
    this._subs.push(this.fileManager.uploadingQueue.state.subscribe(s => this.uploadsQueued = s))
    this._subs.push(this.fileManager.processingItems.state.subscribe(s => this.processing = s))
    
    // search textbox
    this._subs.push(this.searchController.valueChanges.pipe(debounceTime(500)).subscribe(s => {
      this.searchText = s
      if(s && s.length){
        this.fileManager.fourD.V.searchByObject(Folder).contains('name',s).equals('account',this.fileManager.team.value.id).useCache(true).queryObservable().subscribe(s => {
          this.searchFolders = s.items
        })
        this.fileManager.fourD.V.searchByObject(Dataset).contains('name',s).equals('account',this.fileManager.team.value.id).useCache(true).queryObservable().subscribe(s => {
          this.searchFiles = s.items
        })
      }
    }))

  }
  ngOnDestroy(){
    this._subs.forEach(s => s.unsubscribe())
  }

  upload(e){
    this.fileManager.uploadFiles(Array.from(e.srcElement.files),this.selectedFolderStore.value.ref instanceof Folder?this.selectedFolderStore.value.ref:null)
  }

  delFile(d:Dataset){
    d.destroyObservable().subscribe(s => {
      this.displayedFilesStore.emmit(d,'deleted')
      this.displayedFilesStore.remove(d)
    })
  }
  abort(f:FileUpload){
    this.fileManager.uploadingFiles.emmit(f,'abort')
  }

  startAdHoc(ds:Dataset,tt:TransformType,params:any = {}){
    ds.applyTransform(tt,params).subscribe()
    this.curAdHoc = null
  }

  // for the search and folders
  jumpTo(path:string[],params?:any){
    var opt = {relativeTo:this.route}
    if(params)
      opt['queryParams'] = params

    this.router.navigate(path,opt)
    this.searchController.setValue(null)
  }

  treeEvent(ev){
    if(ev.event == 'selected')
      this.jumpTo(['..',ev.item.ref instanceof Folder ? ev.item.ref.id : 'root'])
  }

  fileEvent(ev){
    if(ev.event == 'selected'){
      if(this.keys.isCtrl){
        var exists = this.selectedFilesStore.contains(ev.item)
        var selected = this.selectedFilesStore.values
        if(exists)
          selected.splice(selected.indexOf(ev.item),1)
        else
          selected.push(ev.item)
      }
      else{
        selected = [ev.item]
      }
      var query = selected.length ? {files:selected.reduce((a,f) => a + f.id + ',','').slice(0, -1)} : null
      this.jumpTo([],query)
    }
  }
  
  private setFolder(fid:string){
    // TODO this is a bit messy but basically covers scnarios of jumping to a folder already localed in cache,
    // as well as not loaded and needing sevrer call to find heriachy of folders
    var folderId = parseInt(fid)
    var cached = this.fileManager.fourD.V.findCached(Folder,folderId)
    var foundCached = !!cached
    var chain = []
    if(cached){
      // all items in the folders chain must have been cached
      var par:Folder = cached
      while(par.parent != null){
        chain.unshift(par)
        if(!(par.parent instanceof Folder && this.fileManager.fourD.V.findCached(Folder,par.parent.id))){
          foundCached = false
          break
        }
        par = par.parent
      }
      chain.unshift(par)
    }
    // if its found using local cache use that over hitting server
    if(foundCached){
      this.selectedFolderStore.setWithArgs(this.builder.fromFolder(cached),{chain:chain})
    }
    else{
      this.fileManager.fourD.getFolderChain(folderId).subscribe(res => 
        // important to capture chain in sate so all sub nodes know to open or not
        this.selectedFolderStore.setWithArgs(this.builder.fromFolder(res[0]),{chain:res})
      )
    }
   }
}